<template>
  <div class="navBar">
    <template v-if="navStatus">
      <div class="navBarBox" :class="menuFixed?'navBarActive':''">
        <div class="navLogoBox">
          <router-link class="logo" to="/">
            <img src="@/assets/ty_logo_c.png" v-if="menuFixed" alt="" />
            <img src="@/assets/ty_logo_w.png" v-else alt="" />
            <b>{{logoName}}</b>
          </router-link>
          <div class="navList">
            <ul>
              <li v-for="(item,index) in navList"><router-link :to="{path: item.href,}" :class="index == navIdx?'active':''">{{item.name}}</router-link></li>
            </ul>
          </div>
          <router-link class="releaseBtn" to="/release">发布信息</router-link>
        </div>
      </div>
      <div class="navHeight" v-if="navHeightType"></div>
    </template>
    <ul class="footerNav" v-else>
      <li v-for="(item,index) in navList"><router-link :to="{path: item.href,}" :class="index == navIdx?'btnActive':''">{{item.name}}</router-link></li>
    </ul>
  </div>
</template>

<script>
// import { logoName } from '../util/index';
export default {
  name: 'navBar',
  data() {
    return {
      menuFixed: false,
      navHeightType: false,
      navIdx: 0,
      logoName: logoName,
      navList:[
        {
          name: '首页',
          href:'/',
        },
        {
          name: '品牌LOGO设计',
          href:'/brand',
        },
        {
          name: '软件服务',
          href:'/serve',
        },
        {
          name: '电子商务',
          href:'/business',
        },
        {
          name: '充值中心',
          href:'/recharge',
        },
        // {
        //   name: '动态资讯',
        //   href:'/news',
        // },
      ],
    }
  },
  watch:{
    "$route":{
      immediate: true,
      handler(e) {
        // console.log(this.$route)
        if(this.$route.path == "/"){
          this.menuFixed = false;
          this.navHeightType = false;
          window.addEventListener('scroll', this.handleScroll, true);
        }else{
          this.navHeightType = true;
          this.menuFixed = true;
        }
        this.navList.map((item,index) =>{
          if(this.$route.meta.title == "articles"){
            this.navIdx = index;
            return;
          }
          if(this.$route.params.details != undefined){
            if(item.href == ("/"+this.$route.params.details)){
              this.navIdx = index;
            }
            return;
          }
          if(item.href == this.$route.path){
            this.navIdx = index;
          }
        })
      },
    },
  },
  mounted(){
  },
  methods:{
    //滚动事件
    handleScroll() {
      if(!this.navHeightType){
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        // var offsetTop = document.querySelector('#app').offsetTop // 获取所需元素到文档顶部的距离，然后判断滚动条位置让该元素是否固定定位
        if (scrollTop > 30) {
            this.menuFixed = true
        } else {
            this.menuFixed = false
        }
      }
    },
  },
  destroyed() { //离开这个界面之后，删除滚动事件，不然容易除bug
    window.removeEventListener('scroll', this.handleScroll)
  },
  props: {
    navStatus:{
      type: Boolean,
      default: true,
    },
  }
}
</script>

<style scoped lang="scss">
  .navBarBox{
    display: flex;
    margin:0 auto;
    top:0;
    left:0;
    width:100%;
    z-index: 500;
    position: fixed;
    transition: background 0.3s;
    -webkit-transition: background 0.3s;
    .navLogoBox{
      width:$navWidth;
      padding:20px 0;
      margin:0 auto;
      display: flex;
      align-items: center;
      position: relative;
      .logo{
        margin: 5px 0 0;
        display: flex;
        width:240px;
        img{
          width:40px;
          margin-right:10px;
        }
        b{
          @include h-fontSize(#ffffff,28px,40px);
        }
      }
      .releaseBtn{
        cursor: pointer;
        top:50%;
        right:0;
        position: absolute;
        transition: opacity 0.3s;
        @extend %placeY;
        @include h-btn(120px, 36px, 14px, $color33, 4px, 0, #eccf45, false, none);
        height:36px;
        &:hover{
          @include h-bgColor(#d9b812);
        }
      }
    }
    .navList{
      margin:0 0 0 0;
      ul{
        display: flex;
        margin:0 auto;
        @include h-fontSize($colorFF,14px,48px);
        li{
          width:154px;
          position: relative;
          a{
            text-align: center;
            color: $colorFF;
            display: block;
            &:after{
              content: '';
              display: block;
              transition: width 0.3s;
              width:0;
              height:2px;
              border-radius: 4px;
              position: absolute;
              bottom:10px;
              left:50%;
              @extend %placeX;
            }
            &:hover{
              color: $colorFF;
            }
          }
          .active{
            font-weight: bold;
            color: $colorFF;
            &:after{
              width:14px;
              @include h-bgColor($White);
            }
          }
        }
      }
    }
  }
  .navBarActive{
    box-shadow: 0 0 10px rgba(0,0,0,0.08);
    backdrop-filter: blur(18px);
    @include h-bgColor(var(--navBg));
    .navLogoBox{
      .logo{
        b{
          @include h-fontSize(var(--color00),28px,40px);
        }
      }
      .releaseBtn{
        @include h-btn(120px, 36px, 14px, $colorFF, 4px, 0, $colorE7, false, none);
        &:hover{
          @include h-bgColor($colorF6);
        }
      }
      .navList{
        ul{
          li{
            a{
              color: var(--color22);
              &:after{
                color: var(--color22);
                @include h-bgColor($colorE7);
              }
            }
            .active{
              font-weight: bold;
              color: var(--color00);
            }
          }
        }
      }
    }
  }
  .navHeight{
    width:100%;
    height:88px;
    @include h-bgColor($colorFF);
  }

  .footerNav{
    display: flex;
    justify-content: center;
    li{
      width: (100%/5);
      position: relative;
      text-align: center;
      &::after{
        content: '';
        width:1px;
        height:10px;
        top:50%;
        right:0;
        position: absolute;
        @extend %placeY;
        @include h-border(1px solid var(--colorFF),right);
      }
      &:last-child{
        &::after{
          display: none;
        }
      }
      a{
        display: block;
        transition: color 0.3s;
        @include h-fontSize(var(--colorC3),14px,58px);
        &:hover{
          color: var(--footer-text-color);
        }
      }
      .btnActive{
        color: $colorFF;
        &::before{
          content: '';
          width:16px;
          height:2px;
          bottom:12px;
          left:50%;
          border-radius: 2px;
          position: absolute;
          @extend %placeX;
          @include h-bgColor(var(--colorC3));
        }
      }
    }
  }
</style>
